import type { ChatApiResponse, ChatStructuredResponse } from "@unreserved/types";
type AmenityLink = NonNullable<ChatApiResponse["amenity_links"]>[number];

export interface ListingChatSummary {
    listing_id: string;
    property_title?: string | null;
    summary: string;
    analysis: Record<string, unknown>;
    generated_at: string;
    total_queries: number;
    unique_users_estimate: number;
}

export interface SendAiChatParams {
    listingId: string;
    question: string;
    userId?: string;
}

export async function sendAiChatMessage({
    listingId,
    question,
    userId,
}: SendAiChatParams): Promise<ChatStructuredResponse> {
    const apiUrl = process.env.NEXT_PUBLIC_API_URL_AI || process.env.EXPO_PUBLIC_API_URL_AI;

    const res = await fetch(`${apiUrl}/api/v1/chat/message`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            listing_id: listingId,
            question,
            user_id: userId,
        }),
    });

    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`);
    }

    const data = (await res.json()) as ChatApiResponse;

    return {
        answer: data.answer,
        nearbyPropertiesJson: data.nearby_properties,
        amenityLinks: data.amenity_links?.map((link: AmenityLink) => ({ url: link.url, label: link.label })),
    };
}

export async function getListingChatSummary(listingId: string): Promise<ListingChatSummary> {
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL_AI || process.env.EXPO_PUBLIC_API_URL_AI || '').replace(/\/$/, '');

    const res = await fetch(`${apiUrl}/api/v1/admin/listings/${listingId}/summary`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    if (!res.ok) {
        throw new Error(`Failed to fetch chat summary: ${res.status}`);
    }

    return res.json() as Promise<ListingChatSummary>;
}